import LegalPageEditor from './LegalPageEditor'

const SECTIONS = [{ id: 'main', label: 'Security Content' }]

export default function SecurityCmsPage() {
    return (
        <LegalPageEditor
            page="security"
            liveUrl={`${import.meta.env.VITE_FRONTEND_URL || 'https://tendercentrix.com'}/security`}
            pageTitle="Security Statement — Content Editor"
            pageDescription="Edit the security statement page hero and content. Content is stored as HTML."
            sections={SECTIONS}
        />
    )
}
